import * as React from "react";
import type { SVGProps } from "react";
const SvgBitcoinConvert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path d="M19.167 13.309a5.829 5.829 0 0 1-5.834 5.833l.875-1.458M.833 6.642A5.83 5.83 0 0 1 6.667.809l-.875 1.458M5.517 10.89h2.341c.517 0 .942.467.942.942a.94.94 0 0 1-.942.942H5.517v-1.883Z" />
    <path d="M5.517 12.773H8.2c.592 0 1.075.417 1.075.942 0 .517-.483.942-1.075.942H5.517v-1.884ZM7.017 14.648v.934M7.017 9.957v.933" />
    <path d="M12.375 12.774a5.14 5.14 0 0 1-5.142 5.142 5.14 5.14 0 0 1-5.141-5.142 5.14 5.14 0 0 1 5.141-5.141c.134 0 .259.008.4.016a5.145 5.145 0 0 1 4.734 4.734c0 .125.008.25.008.392Z" />
    <path d="M17.917 7.224a5.14 5.14 0 0 1-5.142 5.141h-.408a5.145 5.145 0 0 0-4.734-4.733v-.408a5.14 5.14 0 0 1 5.142-5.142 5.14 5.14 0 0 1 5.142 5.142Z" />
  </svg>
);
export default SvgBitcoinConvert;
